<template>
    <div>
        <Filters
@apply-filter="applyFilter" @update-items-per-page="updateItemsPerPage"
            @update-view-as-card="updateViewAsCard" />

        <LoadingData v-if="loading" text="Cargando lista de pacientes..." />

        <div v-else>
            <div v-if="!viewAsCard" class="table-responsive">
                <PatientTable :data="filteredItems" @delete-record="deleteItem" />
            </div>

            <transition-group ref="listContainer" name="fade-move" tag="div" class="row me-2 ms-2 pt-2">
                <template v-if="viewAsCard">
                    <PatientCard
v-for="(item) in filteredItems" :key="item.id" ref="listItems" :data="item"
                        class="fade-card" @delete-record="deleteItem" />
                </template>
            </transition-group>

            <Pagination
:total-items="totalFilteredItems" :current-page="currentPage" :last-page="lastPage"
                :items-per-page="itemsPerPage" @page-change="changePage" @create-first="handleCreateFirst" />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, inject, defineEmits } from 'vue';
import { usePatientData } from '@/composables/usePatientData';
import { useObserver } from '@/composables/useObserver';
import Filters from './Filters.vue';
import Pagination from './Pagination.vue';
import LoadingData from './LoadingData.vue';
// ✅ Import corregido - PatientCard movido a MedicalRecord/Patient/
import PatientCard from './MedicalRecord/Patient/PatientCard.vue';
import PatientTable from './PatientTable.vue';

import '@/assets/css/cardstore.css';

const emit = defineEmits(['createFirst']);

const dataStore = 'dataStore';
const resourceApi = 'pacientes';
const swal = inject('$swal');
const listItems = ref([]);
const loading = ref(true); // Bandera de carga

const {
    viewAsCard,
    itemsPerPage,
    totalFilteredItems,
    filteredItems,
    currentPage,
    lastPage,
    fetchItems,
    deleteItem,
    applyFilter,
    updateItemsPerPage,
    updateViewAsCard,
    changePage
} = usePatientData(dataStore, swal, resourceApi);

const { observer, createObserver, handleScroll } = useObserver(listItems);

// Función para manejar el evento de crear primer paciente
const handleCreateFirst = () => {
    emit('createFirst');
};

watch([itemsPerPage, currentPage], ([newItemsPerPage, newPage]) => {
    if (newItemsPerPage || newPage) {
        fetchItems(newPage);
    }
});

onMounted(async () => {
    await fetchItems(); // Esperar a que los datos se carguen
    loading.value = false; // Desactivar la bandera de carga
    createObserver();
    window.addEventListener('scroll', handleScroll);
    handleScroll();
});

onUnmounted(() => {
    if (observer.value) observer.value.disconnect();
    window.removeEventListener('scroll', handleScroll);
});
</script>

<style scoped>
.loading-indicator {
    text-align: center;
    padding: 20px;
    font-size: 1.2em;
}
</style>
